import React, { useEffect, useState } from "react";
import classes from "./PasswordResetMail.module.scss";
import BreadCrumb from "../../molecules/breadcrumb/BreadCrumb";
import { useNavigate } from "react-router-dom";
import headerImage from "../../static/images/title-and-banner.png";
import Header from "../../molecules/header/Header";
import { atom, useAtom } from "jotai";
import { mailAtom } from "../../atoms/mail/Mail";
import teacherImage from "../../static/images/teacher-mail.png";

function PasswordResetMail() {
  const navigate = useNavigate();
  const [email, setEmail] = useAtom(mailAtom);

  return (
    <div className={classes.container}>
      <Header />
      <div className={classes.body}>
        <img className={classes.header} src={headerImage} alt={headerImage} />
        <img src={teacherImage} alt={teacherImage} />
        <div className={classes.summary}>
          メールを送信しました
        </div>
        <div className={classes.email}>{email}</div>
        <div className={classes.text}>
          に、「みらいいコンシェル{" "}
          <span className={classes.strong}>
            &lt;support@miraii-concierge.jp&gt;
          </span>
          」からご案内のメールをお送りしました。数分経っても届かない場合は、迷惑メールフォルダをご確認ください。
        </div>
        <div className={classes.caption}>
          <div
            className={`${classes.title} ${classes.text} ${classes.red} ${classes.strong} ${classes.center}`}
          >
            メールが届きませんか？
          </div>
          <div className={`${classes.text} ${classes.red}`}>
            入力いただいたメールアドレスが登録されていないか、登録いただいた際にメールアドレスが誤っていた可能性がございます。お手数ですが
            <a
              className={classes.link}
              target="_blank"
              rel="noreferrer"
              href="https://form.run/@miraii-concierge-contact"
            >
              こちらのリンク
            </a>
            から再度お試しください<div className=""></div>
          </div>
        </div>
        <BreadCrumb
          data={[
            { displayName: "みらいいコンシェル", url: "/home" },
            { displayName: "ログイン", url: "/login" },
            { displayName: "パスワード再設定" },
            { displayName: "メール送信完了" },
          ]}
        />
      </div>
    </div>
  );
}

export default PasswordResetMail;
